import React from 'react'
import ArchivingPanel from "./ArchivingPanel";

function Index(
    {
        expanded
    }) {
    return (expanded && <ArchivingPanel />)
}


export default Index;